
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

$parcel$export(module.exports, "ForgeContentTools", () => $0c33e41081c1500e$export$7cf22b806dbb23cb);
/* ForgeContentTools.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fppBw = parcelRequire("fppBw");

var $inPa6 = parcelRequire("inPa6");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $7QUD1 = parcelRequire("7QUD1");
var $7Ndnw = parcelRequire("7Ndnw");
var $8a9Dm = parcelRequire("8a9Dm");
var $hIaUw = parcelRequire("hIaUw");
var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");

var $ep3mz = parcelRequire("ep3mz");

var $6UqI3 = parcelRequire("6UqI3");
var $6uUjl = parcelRequire("6uUjl");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $5ZqQS = parcelRequire("5ZqQS");

var $3jwuS = parcelRequire("3jwuS");

var $041p6 = parcelRequire("041p6");

var $9MrOn = parcelRequire("9MrOn");
const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, dialogs: dialogs, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $gwFzn.useState)(null);
    const [isLoading, setLoading] = (0, $gwFzn.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $gwFzn.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $gwFzn.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $gwFzn.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $gwFzn.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]); // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $gwFzn.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9MrOn.ContentToolsButton), {
                isLoading: true // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                ,
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, undefined, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB,
        dialogs: dialogs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $dIouf.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $041p6.ForgeContentToolsItem), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const onInitialRender = (0, $gwFzn.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: onClose,
        dialogs: dialogs
    }));
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired
};

});
parcelRegister("7QUD1", function(module, exports) {

$parcel$export(module.exports, "ByLineForgeApp", () => $02976f123c8f8e25$export$d2159b9f3f077903);
$parcel$export(module.exports, "ContentActionForgeApp", () => $02976f123c8f8e25$export$f900958ce7c4410f);
$parcel$export(module.exports, "ContextMenuForgeApp", () => $02976f123c8f8e25$export$79ed117743c6c2cf);
$parcel$export(module.exports, "GlobalPageForgeApp", () => $02976f123c8f8e25$export$83db8797814193a8);
$parcel$export(module.exports, "GlobalSettingsForgeApp", () => $02976f123c8f8e25$export$74528162c4c3828b);
$parcel$export(module.exports, "HomepageFeedForgeApp", () => $02976f123c8f8e25$export$c8291e2d6d6adbf2);
$parcel$export(module.exports, "SpaceSettingsForgeApp", () => $02976f123c8f8e25$export$e8858129e933f7e8);
$parcel$export(module.exports, "CustomContentForgeApp", () => $02976f123c8f8e25$export$578d0cbdb0ffa72e);
$parcel$export(module.exports, "BackgroundScriptForgeApp", () => $02976f123c8f8e25$export$40d4b5cfa6c18ea7);
$parcel$export(module.exports, "PageBannerForgeApp", () => $02976f123c8f8e25$export$c76787f94e0b1609);

var $jmjWc = parcelRequire("jmjWc");

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("5TI5V"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("6dsKj"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("fHa4B"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("cMegJ"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("6iAnM"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("is6kj"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("lvMFo"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("fvP16"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("1yZPP"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("6lLxf"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("b1MIs"))).PageBannerForgeApp
});

});
parcelRegister("5TI5V", function(module, exports) {

let $44b44b0d0fcf11e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $44b44b0d0fcf11e8$var$load("hf7yW"),
    $44b44b0d0fcf11e8$var$load("cza5I"),
    $44b44b0d0fcf11e8$var$load("lnKog"),
    $44b44b0d0fcf11e8$var$load("9L8th"),
    $44b44b0d0fcf11e8$var$load("2aE9V"),
    $44b44b0d0fcf11e8$var$load("iQ0Jm"),
    $44b44b0d0fcf11e8$var$load("gkmZg"),
    $44b44b0d0fcf11e8$var$load("h4Nf7"),
    $44b44b0d0fcf11e8$var$load("05d2I"),
    $44b44b0d0fcf11e8$var$load("fqZPY"),
    $44b44b0d0fcf11e8$var$load("9ybBP"),
    $44b44b0d0fcf11e8$var$load("fsZ6i"),
    $44b44b0d0fcf11e8$var$load("hP2ev"),
    $44b44b0d0fcf11e8$var$load("6FRhD"),
    $44b44b0d0fcf11e8$var$load("iIRyn"),
    $44b44b0d0fcf11e8$var$load("fYhfO"),
    $44b44b0d0fcf11e8$var$load("g9CVe"),
    $44b44b0d0fcf11e8$var$load("4Bp5z"),
    $44b44b0d0fcf11e8$var$load("6gqpV"),
    $44b44b0d0fcf11e8$var$load("aZinD"),
    $44b44b0d0fcf11e8$var$load("6qah4"),
    $44b44b0d0fcf11e8$var$load("ffEVr"),
    $44b44b0d0fcf11e8$var$load("joJy8"),
    $44b44b0d0fcf11e8$var$load("aHE9G"),
    $44b44b0d0fcf11e8$var$load("c6MKV"),
    $44b44b0d0fcf11e8$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("6dsKj", function(module, exports) {

let $486a415a13ea0407$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $486a415a13ea0407$var$load("hf7yW"),
    $486a415a13ea0407$var$load("cza5I"),
    $486a415a13ea0407$var$load("lnKog"),
    $486a415a13ea0407$var$load("9L8th"),
    $486a415a13ea0407$var$load("2aE9V"),
    $486a415a13ea0407$var$load("iQ0Jm"),
    $486a415a13ea0407$var$load("gkmZg"),
    $486a415a13ea0407$var$load("h4Nf7"),
    $486a415a13ea0407$var$load("05d2I"),
    $486a415a13ea0407$var$load("fqZPY"),
    $486a415a13ea0407$var$load("9ybBP"),
    $486a415a13ea0407$var$load("fsZ6i"),
    $486a415a13ea0407$var$load("hP2ev"),
    $486a415a13ea0407$var$load("6FRhD"),
    $486a415a13ea0407$var$load("iIRyn"),
    $486a415a13ea0407$var$load("fYhfO"),
    $486a415a13ea0407$var$load("g9CVe"),
    $486a415a13ea0407$var$load("4Bp5z"),
    $486a415a13ea0407$var$load("6gqpV"),
    $486a415a13ea0407$var$load("aZinD"),
    $486a415a13ea0407$var$load("6qah4"),
    $486a415a13ea0407$var$load("ffEVr"),
    $486a415a13ea0407$var$load("joJy8"),
    $486a415a13ea0407$var$load("aHE9G"),
    $486a415a13ea0407$var$load("c6MKV"),
    $486a415a13ea0407$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("fHa4B", function(module, exports) {

let $b6d2af7fd8b86482$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b6d2af7fd8b86482$var$load("hf7yW"),
    $b6d2af7fd8b86482$var$load("cza5I"),
    $b6d2af7fd8b86482$var$load("lnKog"),
    $b6d2af7fd8b86482$var$load("9L8th"),
    $b6d2af7fd8b86482$var$load("2aE9V"),
    $b6d2af7fd8b86482$var$load("iQ0Jm"),
    $b6d2af7fd8b86482$var$load("gkmZg"),
    $b6d2af7fd8b86482$var$load("h4Nf7"),
    $b6d2af7fd8b86482$var$load("05d2I"),
    $b6d2af7fd8b86482$var$load("fqZPY"),
    $b6d2af7fd8b86482$var$load("9ybBP"),
    $b6d2af7fd8b86482$var$load("fsZ6i"),
    $b6d2af7fd8b86482$var$load("hP2ev"),
    $b6d2af7fd8b86482$var$load("6FRhD"),
    $b6d2af7fd8b86482$var$load("iIRyn"),
    $b6d2af7fd8b86482$var$load("fYhfO"),
    $b6d2af7fd8b86482$var$load("g9CVe"),
    $b6d2af7fd8b86482$var$load("4Bp5z"),
    $b6d2af7fd8b86482$var$load("6gqpV"),
    $b6d2af7fd8b86482$var$load("aZinD"),
    $b6d2af7fd8b86482$var$load("6qah4"),
    $b6d2af7fd8b86482$var$load("ffEVr"),
    $b6d2af7fd8b86482$var$load("joJy8"),
    $b6d2af7fd8b86482$var$load("aHE9G"),
    $b6d2af7fd8b86482$var$load("c6MKV"),
    $b6d2af7fd8b86482$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("cMegJ", function(module, exports) {

let $94d509417f8a4c64$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $94d509417f8a4c64$var$load("fqZPY"),
    $94d509417f8a4c64$var$load("9ybBP"),
    $94d509417f8a4c64$var$load("9L8th"),
    $94d509417f8a4c64$var$load("gkmZg"),
    $94d509417f8a4c64$var$load("h4Nf7"),
    $94d509417f8a4c64$var$load("fsZ6i"),
    $94d509417f8a4c64$var$load("hP2ev"),
    $94d509417f8a4c64$var$load("6FRhD"),
    $94d509417f8a4c64$var$load("iIRyn"),
    $94d509417f8a4c64$var$load("fYhfO"),
    $94d509417f8a4c64$var$load("g9CVe"),
    $94d509417f8a4c64$var$load("6qah4"),
    $94d509417f8a4c64$var$load("4Bp5z"),
    $94d509417f8a4c64$var$load("6gqpV"),
    $94d509417f8a4c64$var$load("aZinD"),
    $94d509417f8a4c64$var$load("ffEVr"),
    $94d509417f8a4c64$var$load("joJy8"),
    $94d509417f8a4c64$var$load("aHE9G"),
    $94d509417f8a4c64$var$load("c6MKV"),
    $94d509417f8a4c64$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("6iAnM", function(module, exports) {

let $4960a55b86e65647$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4960a55b86e65647$var$load("fqZPY"),
    $4960a55b86e65647$var$load("9ybBP"),
    $4960a55b86e65647$var$load("9L8th"),
    $4960a55b86e65647$var$load("gkmZg"),
    $4960a55b86e65647$var$load("h4Nf7"),
    $4960a55b86e65647$var$load("fsZ6i"),
    $4960a55b86e65647$var$load("hP2ev"),
    $4960a55b86e65647$var$load("6FRhD"),
    $4960a55b86e65647$var$load("iIRyn"),
    $4960a55b86e65647$var$load("fYhfO"),
    $4960a55b86e65647$var$load("g9CVe"),
    $4960a55b86e65647$var$load("6qah4"),
    $4960a55b86e65647$var$load("4Bp5z"),
    $4960a55b86e65647$var$load("6gqpV"),
    $4960a55b86e65647$var$load("aZinD"),
    $4960a55b86e65647$var$load("ffEVr"),
    $4960a55b86e65647$var$load("joJy8"),
    $4960a55b86e65647$var$load("aHE9G"),
    $4960a55b86e65647$var$load("c6MKV"),
    $4960a55b86e65647$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("is6kj", function(module, exports) {

let $d6efbfd75168e1a8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $d6efbfd75168e1a8$var$load("fqZPY"),
    $d6efbfd75168e1a8$var$load("9ybBP"),
    $d6efbfd75168e1a8$var$load("cza5I"),
    $d6efbfd75168e1a8$var$load("lnKog"),
    $d6efbfd75168e1a8$var$load("9L8th"),
    $d6efbfd75168e1a8$var$load("gkmZg"),
    $d6efbfd75168e1a8$var$load("h4Nf7"),
    $d6efbfd75168e1a8$var$load("fsZ6i"),
    $d6efbfd75168e1a8$var$load("hP2ev"),
    $d6efbfd75168e1a8$var$load("6FRhD"),
    $d6efbfd75168e1a8$var$load("iIRyn"),
    $d6efbfd75168e1a8$var$load("fYhfO"),
    $d6efbfd75168e1a8$var$load("g9CVe"),
    $d6efbfd75168e1a8$var$load("6qah4"),
    $d6efbfd75168e1a8$var$load("4Bp5z"),
    $d6efbfd75168e1a8$var$load("6gqpV"),
    $d6efbfd75168e1a8$var$load("aZinD"),
    $d6efbfd75168e1a8$var$load("ffEVr"),
    $d6efbfd75168e1a8$var$load("joJy8"),
    $d6efbfd75168e1a8$var$load("aHE9G"),
    $d6efbfd75168e1a8$var$load("c6MKV"),
    $d6efbfd75168e1a8$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("lvMFo", function(module, exports) {

let $fa923e6c66a01e15$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fa923e6c66a01e15$var$load("8DoxJ"),
    $fa923e6c66a01e15$var$load("cza5I"),
    $fa923e6c66a01e15$var$load("lnKog"),
    $fa923e6c66a01e15$var$load("9L8th"),
    $fa923e6c66a01e15$var$load("gkmZg"),
    $fa923e6c66a01e15$var$load("h4Nf7"),
    $fa923e6c66a01e15$var$load("fqZPY"),
    $fa923e6c66a01e15$var$load("9ybBP"),
    $fa923e6c66a01e15$var$load("fsZ6i"),
    $fa923e6c66a01e15$var$load("hP2ev"),
    $fa923e6c66a01e15$var$load("6FRhD"),
    $fa923e6c66a01e15$var$load("iIRyn"),
    $fa923e6c66a01e15$var$load("fYhfO"),
    $fa923e6c66a01e15$var$load("dTsOE"),
    $fa923e6c66a01e15$var$load("g9CVe"),
    $fa923e6c66a01e15$var$load("6qah4"),
    $fa923e6c66a01e15$var$load("4Bp5z"),
    $fa923e6c66a01e15$var$load("6gqpV"),
    $fa923e6c66a01e15$var$load("aZinD"),
    $fa923e6c66a01e15$var$load("ffEVr"),
    $fa923e6c66a01e15$var$load("joJy8"),
    $fa923e6c66a01e15$var$load("aHE9G"),
    $fa923e6c66a01e15$var$load("c6MKV"),
    $fa923e6c66a01e15$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("fvP16", function(module, exports) {

let $b4b1532034b6de5d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b4b1532034b6de5d$var$load("8DoxJ"),
    $b4b1532034b6de5d$var$load("cza5I"),
    $b4b1532034b6de5d$var$load("lnKog"),
    $b4b1532034b6de5d$var$load("9L8th"),
    $b4b1532034b6de5d$var$load("gkmZg"),
    $b4b1532034b6de5d$var$load("h4Nf7"),
    $b4b1532034b6de5d$var$load("fqZPY"),
    $b4b1532034b6de5d$var$load("9ybBP"),
    $b4b1532034b6de5d$var$load("fsZ6i"),
    $b4b1532034b6de5d$var$load("hP2ev"),
    $b4b1532034b6de5d$var$load("6FRhD"),
    $b4b1532034b6de5d$var$load("iIRyn"),
    $b4b1532034b6de5d$var$load("fYhfO"),
    $b4b1532034b6de5d$var$load("dTsOE"),
    $b4b1532034b6de5d$var$load("g9CVe"),
    $b4b1532034b6de5d$var$load("6qah4"),
    $b4b1532034b6de5d$var$load("4Bp5z"),
    $b4b1532034b6de5d$var$load("6gqpV"),
    $b4b1532034b6de5d$var$load("aZinD"),
    $b4b1532034b6de5d$var$load("ffEVr"),
    $b4b1532034b6de5d$var$load("joJy8"),
    $b4b1532034b6de5d$var$load("aHE9G"),
    $b4b1532034b6de5d$var$load("c6MKV"),
    $b4b1532034b6de5d$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("1yZPP", function(module, exports) {

let $1238ee903e3ef7a8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1238ee903e3ef7a8$var$load("fqZPY"),
    $1238ee903e3ef7a8$var$load("9ybBP"),
    $1238ee903e3ef7a8$var$load("9L8th"),
    $1238ee903e3ef7a8$var$load("gkmZg"),
    $1238ee903e3ef7a8$var$load("h4Nf7"),
    $1238ee903e3ef7a8$var$load("fsZ6i"),
    $1238ee903e3ef7a8$var$load("hP2ev"),
    $1238ee903e3ef7a8$var$load("6FRhD"),
    $1238ee903e3ef7a8$var$load("iIRyn"),
    $1238ee903e3ef7a8$var$load("fYhfO"),
    $1238ee903e3ef7a8$var$load("g9CVe"),
    $1238ee903e3ef7a8$var$load("6qah4"),
    $1238ee903e3ef7a8$var$load("4Bp5z"),
    $1238ee903e3ef7a8$var$load("6gqpV"),
    $1238ee903e3ef7a8$var$load("aZinD"),
    $1238ee903e3ef7a8$var$load("ffEVr"),
    $1238ee903e3ef7a8$var$load("joJy8"),
    $1238ee903e3ef7a8$var$load("aHE9G"),
    $1238ee903e3ef7a8$var$load("c6MKV"),
    $1238ee903e3ef7a8$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("6lLxf", function(module, exports) {

let $49f993bb9030f5c8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $49f993bb9030f5c8$var$load("fqZPY"),
    $49f993bb9030f5c8$var$load("9ybBP"),
    $49f993bb9030f5c8$var$load("cza5I"),
    $49f993bb9030f5c8$var$load("lnKog"),
    $49f993bb9030f5c8$var$load("9L8th"),
    $49f993bb9030f5c8$var$load("gkmZg"),
    $49f993bb9030f5c8$var$load("h4Nf7"),
    $49f993bb9030f5c8$var$load("fsZ6i"),
    $49f993bb9030f5c8$var$load("hP2ev"),
    $49f993bb9030f5c8$var$load("6FRhD"),
    $49f993bb9030f5c8$var$load("iIRyn"),
    $49f993bb9030f5c8$var$load("fYhfO"),
    $49f993bb9030f5c8$var$load("g9CVe"),
    $49f993bb9030f5c8$var$load("6qah4"),
    $49f993bb9030f5c8$var$load("4Bp5z"),
    $49f993bb9030f5c8$var$load("6gqpV"),
    $49f993bb9030f5c8$var$load("aZinD"),
    $49f993bb9030f5c8$var$load("ffEVr"),
    $49f993bb9030f5c8$var$load("joJy8"),
    $49f993bb9030f5c8$var$load("aHE9G"),
    $49f993bb9030f5c8$var$load("c6MKV"),
    $49f993bb9030f5c8$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("b1MIs", function(module, exports) {

let $807593b0138f79b7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $807593b0138f79b7$var$load("fqZPY"),
    $807593b0138f79b7$var$load("9ybBP"),
    $807593b0138f79b7$var$load("cza5I"),
    $807593b0138f79b7$var$load("lnKog"),
    $807593b0138f79b7$var$load("9L8th"),
    $807593b0138f79b7$var$load("gkmZg"),
    $807593b0138f79b7$var$load("h4Nf7"),
    $807593b0138f79b7$var$load("fsZ6i"),
    $807593b0138f79b7$var$load("hP2ev"),
    $807593b0138f79b7$var$load("6FRhD"),
    $807593b0138f79b7$var$load("iIRyn"),
    $807593b0138f79b7$var$load("fYhfO"),
    $807593b0138f79b7$var$load("g9CVe"),
    $807593b0138f79b7$var$load("6qah4"),
    $807593b0138f79b7$var$load("4Bp5z"),
    $807593b0138f79b7$var$load("6gqpV"),
    $807593b0138f79b7$var$load("aZinD"),
    $807593b0138f79b7$var$load("ffEVr"),
    $807593b0138f79b7$var$load("joJy8"),
    $807593b0138f79b7$var$load("aHE9G"),
    $807593b0138f79b7$var$load("c6MKV"),
    $807593b0138f79b7$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});


parcelRegister("8a9Dm", function(module, exports) {

$parcel$export(module.exports, "getAppId", () => $2cc1b73219e08564$export$fb2283f4a44fb53);
$parcel$export(module.exports, "getModuleKey", () => $2cc1b73219e08564$export$b17b21a48c0a3273);
$parcel$export(module.exports, "getCustomContentType", () => $2cc1b73219e08564$export$9eb690901638fb96);
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};

});

parcelRegister("dizL5", function(module, exports) {

$parcel$export(module.exports, "lazyForgeUIExtensionsWithLoader", () => $55b20ed34f146485$export$350b371bfb7f5e95);
$parcel$export(module.exports, "LazyForgeUIExtensions", () => $55b20ed34f146485$export$4cbc6d03d50a8849);

var $jmjWc = parcelRequire("jmjWc");

const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("5BwFR"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);

});
parcelRegister("5BwFR", function(module, exports) {

let $4149c0d95b46dcb7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $4149c0d95b46dcb7$var$load("cza5I"),
    $4149c0d95b46dcb7$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});


parcelRegister("6UqI3", function(module, exports) {

$parcel$export(module.exports, "getSpaceType", () => $a3c7cd489159fe33$export$28eddf802cd184f7);
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};

});

parcelRegister("041p6", function(module, exports) {

$parcel$export(module.exports, "ForgeContentToolsItem", () => $ced39bfea5ef5993$export$9f275aff884e1431);
/* ForgeContentToolsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fppBw = parcelRequire("fppBw");

var $9hlns = parcelRequire("9hlns");

var $9fBoq = parcelRequire("9fBoq");

var $al4VD = parcelRequire("al4VD");
const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz131l" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
function $ced39bfea5ef5993$export$9f275aff884e1431({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $gwFzn.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired
};

});
parcelRegister("9fBoq", function(module, exports) {

$parcel$export(module.exports, "extensionTitle", () => $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e);

var $1c598 = parcelRequire("1c598");
const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1c598.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1c598.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};

});


parcelRegister("9MrOn", function(module, exports) {

$parcel$export(module.exports, "ContentToolsButton", () => $43c0d8bb08806c39$export$f221d384e5b0f4c3);
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fppBw = parcelRequire("fppBw");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $9VJDA = parcelRequire("9VJDA");

var $1qfLF = parcelRequire("1qfLF");

var $52EPl = parcelRequire("52EPl");

var $blsJs = parcelRequire("blsJs");

var $j8UzL = parcelRequire("j8UzL");
const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $2nPZH.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isLoading: isLoading, preloadCopyItem: preloadCopyItem, preloadMoveItem: preloadMoveItem, isExternalCollaborator: isExternalCollaborator = false })=>{
    const intl = (0, $dBxQj.default)();
    const [showSpinner, setSpinner] = (0, $gwFzn.useState)(false);
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $gwFzn.useState)('auto');
    const dropdownMenuContainerRef = (0, $gwFzn.useRef)(null);
    (0, $blsJs.useSubmitSSRScriptErrors)('page-more-action-button');
    const isMoreActionButtonClickedInSSR = ()=>Boolean(window.__SSR_EVENTS_CAPTURE__?.moreActionButton && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        (window.__SSR_RENDERED__ || undefined));
    const handleOnOpenChange = (obj)=>{
        if (window.__SSR_RENDERED__ && isLoading) {
            if (!window.__SSR_EVENTS_CAPTURE__) window.__SSR_EVENTS_CAPTURE__ = {};
            window.__SSR_EVENTS_CAPTURE__.moreActionButton = true;
            setSpinner(true);
        }
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    (0, $gwFzn.useEffect)(()=>{
        const handleButton = async ()=>{
            if (isMoreActionButtonClickedInSSR()) {
                if (!isLoading) {
                    await preloadCopyItem?.();
                    await preloadMoveItem?.();
                    handleOnOpenChange({
                        isOpen: true
                    });
                    setSpinner(false);
                    delete window.__SSR_EVENTS_CAPTURE__?.moreActionButton;
                } else //if clicked in SSR, gotta show spinner even when SPA takes over while loading
                setSpinner(true);
            }
        };
        handleButton(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoading
    ]);
    if (isMoreActionButtonClickedInSSR() && showSpinner) {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        const SSR_ACTION_LOADING_SPINNER_STYLE = {
            marginLeft: '10px'
        };
        return /*#__PURE__*/ $gwFzn.createElement((0, $j8UzL.SSRActionLoadingSpinner), {
            spinnerId: "more-action-loading-spinner",
            actionType: "moreActionButton",
            showSpinner: true // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ,
            styleOverride: SSR_ACTION_LOADING_SPINNER_STYLE
        });
    }
    return /*#__PURE__*/ $gwFzn.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $35pXk.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $gwFzn.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $gwFzn.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $gwFzn.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    preloadCopyItem: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    preloadMoveItem: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $gwFzn.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);

});
parcelRegister("blsJs", function(module, exports) {

$parcel$export(module.exports, "useSubmitSSRScriptErrors", () => $7bdb5572ed9c8600$export$290a00987d4ffd42);

var $gwFzn = parcelRequire("gwFzn");

var $5ZqQS = parcelRequire("5ZqQS");
const $7bdb5572ed9c8600$export$290a00987d4ffd42 = (scope)=>{
    (0, $gwFzn.useEffect)(()=>{
        if (!window.__SSR_CLIENT_ERRORS__ || !window.__SSR_CLIENT_ERRORS__[scope]) return;
        const ssrErrors = window.__SSR_CLIENT_ERRORS__[scope];
        ssrErrors.forEach((error)=>(0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: 'backbone'
            }));
        delete window.__SSR_CLIENT_ERRORS__[scope];
    }, [
        scope
    ]);
};

});



parcelRegister("4vC63", function(module, exports) {

$parcel$export(module.exports, "ForgeKeyboardShortcutVisualizer", () => $c1fece3650e281b8$export$b804abdac3f5f117);
$parcel$export(module.exports, "ForgeKeyboardShortcut", () => $c1fece3650e281b8$export$4e51bfd8ba3e71ef);

var $gwFzn = parcelRequire("gwFzn");

var $3gadb = parcelRequire("3gadb");

var $ljm2R = parcelRequire("ljm2R");
const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $ljm2R.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $ljm2R.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $ljm2R.ShortcutType).Forge
    }));
    return null;
};

});


//# sourceMappingURL=ForgeContentTools.7ba5169c.js.map
